import globalevents_controller from '../globalevents/globalevents_controller'
import animations_controller from '../animations/animations_controller'
import { utility_controller, Utility } from '../utility/utility_controller'
import projects_overlays from '../projects_overlays/projects_overlays'
import page_settings_styles_restore from '../projects_overlays/page_settings_styles_restore'
import preload_controller from './preload'
import shortcodes_controller from '../shortcodes/shortcodes_controller'
import history_controller from '../history/history_controller_new'
import { canCachePage } from '../history/navigation_policy'

var layout_controller = {
	showLayout: function (password = '', callback = '') {
		showLayout(password, callback)
	},
	i: function () {
		i()
	},
	hideRegions: function () {
		hideRegions()
	},
	abortFetch: function () {
		abortFetch()
	},
	preloadLayout: function (id, type) {
		preload_controller.preloadLayout(id, type)
	},
	clearPreloadCache: function () {
		preload_controller.clearPreloadCache()
	},
	getPreloadCacheStats: function () {
		return preload_controller.getPreloadCacheStats()
	},
	getStateMap: function () {
		return stateMap
	},
	loadMasterCache: function () {
		loadMasterCache()
	},
}

var stateMap = {
	type: null,
	isFirstLoad: true,
	gridObj: null,
	masterCache: null,
}

var jqueryMap = {
	$body: null,
}

var setjqueryMap = function () {
	jqueryMap.$body = jQuery('body')
}

var progress = null

var abortFetch = function () {
	if (progress) {
		progress.abort()
	}
}

var showLayout = function (password, callback) {
	var type = jqueryMap.$body.attr('data-type')
	var id = jqueryMap.$body.attr('data-id')
	stateMap.type = type

	// Determine early if this navigation will open/use project overlay.
	// Must happen before any cache early-return so snapshot is always present.
	var is_project_overlay = 'false'
	if (type == 'project' && window.utility_controller.isProjectsOverlayEnabled()) {
		is_project_overlay = projects_overlays.shouldOpenOverlay() || projects_overlays.isOverlayDisplayBlock() ? 'true' : 'false'
	}
	page_settings_styles_restore.captureSnapshotBeforeOverlayFetch({
		isProjectOverlay: is_project_overlay,
		shouldOpenOverlay: projects_overlays.shouldOpenOverlay(),
		basePageId: projects_overlays.getOverviewPageId(),
		type: type,
		id: id,
	})

	// `layData.activate_lay_cache` is the JSON-encoded return of
	// Lay_Layout_Cache::is_cache_enabled() in PHP. wp_localize_script flattens
	// booleans to strings: PHP `true` → '1', PHP `false` → ''. Comparing
	// against 'on' (a leftover from the option name) is wrong and silently
	// disabled the entire navigation cache path.
	let useCache = layData.activate_lay_cache == '1' && canCachePage({ id, type }, window.location.href)
	let hasShortcode = shortcodes_controller.pageContainsShortcode(window.history.state)

	if (useCache && !hasShortcode) {
		// Check master cache first (no password required).
		// Master cache is keyed by id only on the server side and the cached
		// markup is translated to whatever language was active when the cache
		// was built. With qTranslate-XT we'd risk serving the wrong language
		// (no way to know the entry's language from the JS side), so skip
		// this shortcut whenever qTranslate is active and rely on the
		// per-language preloadCache instead.
		var masterCacheKey = is_project_overlay == 'true' ? 'project_overlay_' + id : id
		if (password === '' && !layData.is_qtranslate_active && stateMap.masterCache && stateMap.masterCache[masterCacheKey]) {
			afterSuccess({ layout: stateMap.masterCache[masterCacheKey] }, password, callback)
			return
		}

		// Check if we have preloaded data
		var cachedData = preload_controller.getCachedData(id, type, is_project_overlay)

		if (cachedData && password === '') {
			afterSuccess(cachedData, password, callback)
			return
		}
	}

	var ajax_data = {
		action: 'get_laytheme_layout',
		is_project_overlay: is_project_overlay,
		id: id,
		type: type,
		password: password,
	}
	var ajaxLang = preload_controller.getUrlLangForRequest(window.location.href)
	if (ajaxLang !== '') {
		// qTranslate-XT detects admin-ajax request language from `lang`.
		// Without this, path-based language URLs in a WP subdirectory can fall
		// back to the default language, especially with hide_default_language on.
		ajax_data.lang = ajaxLang
	}

	if (progress) {
		progress.abort()
	}
	progress = jQuery.ajax({
		url: layData.ajax_url,
		data: ajax_data,
		type: 'post',
		success: (json) => {
			var result = window.JSON.parse(json)
			// Stash the response so a re-visit of this page during the same
			// session is instant — the JS-side master cache snapshot taken
			// at page load doesn't yet know about pages added since.
			if (password === '') {
				preload_controller.cacheResult(id, type, result, is_project_overlay)
			}
			afterSuccess(result, password, callback)
		},
		error: (event) => {},
	})
}

var afterSuccess = function (result, password, callback) {
	if (result.requiresFullPageLoad) {
		window.location.reload()
		return
	}
	if (result.hasOwnProperty('layout') && result.layout.hasOwnProperty('password') && result.layout.password == 'protected') {
		window.location.reload()
		return
	}

	if (password != '') {
		// since there is no reveal animation first do this, then show content
		animations_controller.doAfterComplete()
		status == 'ended'
	}
	// has element transition-out ended? if not, bind on end
	// this way we immediately start transition-in after transition-out ended,
	// or we have waited until things have loaded and transition-out has already ended
	var status = animations_controller.getTransitionStatus()
	if (status == 'ended') {
		replaceContentAndFireEvents(callback, result.layout)
	} else {
		window.laytheme.once('transition_navigation_out_completed', function () {
			replaceContentAndFireEvents(callback, result.layout)
		})
	}
}

var lastFooterId = -1

var replaceContentAndFireEvents = function (callback, result) {
	// Loading indicator (`.po-content-loading` on `#lay-project-overlay`) was
	// added in history_controller_new.js when the click started fetching new
	// content. By the time we get here the content is in hand and about to
	// be inserted, so the indicator is no longer needed — regardless of
	// which of the three branches below ends up running. Previously only the
	// `shouldOpenOverlay()` branch removed it; project-to-project nav and
	// the close/plain-nav branch left the class stuck on the overlay.
	// `removeClass` on a missing class is a no-op, so this is safe even when
	// no indicator was ever added.
	projects_overlays.removeLoadingIndicator()

	if (projects_overlays.shouldOpenOverlay() || projects_overlays.isOverlayDisplayBlock()) {
		// this hides content of project overlay so that it can be animated in. otherwise we would have a flash of text for example
		window.laytheme.emit('before_content_replacement_for_project_overlay')
	} else {
		window.laytheme.emit('before_content_replacement')
	}
	if (typeof callback == 'function') {
		callback()
	}

	// when this setting is turned on, the user uses the split screen tutorial: https://laytheme.com/tutorials/create-a-splitscreen-website.html

	// todo: make splitscreen work with projects overlays
	if (layData.never_change_scrolling_position == 'on' && !projects_overlays.shouldOpenOverlay()) {
		// in that case, we just dont replace the footer markup :D
		// this way, the markup of the left side of the splitscreen website will remain states like thumbnailgrid filtering
		$resultMarkup = jQuery(result['markup'])
		var $currentLayContent = jQuery('body>.lay-content')

		// Update .lay-content classes based on what's in the new markup
		// Check if new markup has custom phone grid
		var hasCustomPhoneGrid = $resultMarkup.find('#custom-phone-grid').length > 0
		var hasFooterCustomPhoneGrid = $resultMarkup.find('#footer-custom-phone-grid').length > 0

		// Update main phone grid classes
		$currentLayContent.removeClass('hascustomphonegrid nocustomphonegrid')
		if (hasCustomPhoneGrid) {
			$currentLayContent.addClass('hascustomphonegrid')
		} else {
			$currentLayContent.addClass('nocustomphonegrid')
		}

		// Update footer phone grid classes
		$currentLayContent.removeClass('footer-hascustomphonegrid footer-nocustomphonegrid')
		if (hasFooterCustomPhoneGrid) {
			$currentLayContent.addClass('footer-hascustomphonegrid')
		} else {
			$currentLayContent.addClass('footer-nocustomphonegrid')
		}

		jQuery('body>.lay-content').find('#grid').replaceWith($resultMarkup.find('#grid'))

		// Handle custom phone grid
		var $currentCustomPhoneGrid = jQuery('body>.lay-content').find('#custom-phone-grid')
		if ($currentCustomPhoneGrid.length > 0 && hasCustomPhoneGrid) {
			// Replace existing custom phone grid
			$currentCustomPhoneGrid.replaceWith($resultMarkup.find('#custom-phone-grid'))
		} else if ($currentCustomPhoneGrid.length > 0 && !hasCustomPhoneGrid) {
			// Remove custom phone grid if new page doesn't have one
			$currentCustomPhoneGrid.remove()
		} else if ($currentCustomPhoneGrid.length === 0 && hasCustomPhoneGrid) {
			// Add custom phone grid if new page has one but current page doesn't
			jQuery('body>.lay-content').append($resultMarkup.find('#custom-phone-grid'))
		}

		// only replace footer content if a different footer was chosen for current page!!
		if (result.obj.footerid != lastFooterId) {
			jQuery('body>.lay-content').find('#footer-region').replaceWith($resultMarkup.find('#footer-region'))
		}
		lastFooterId = result.obj.footerid
		utility_controller.setBodyClasses(result['obj'])
		globalevents_controller.triggerNewPageShown({}, result['type'], result['obj'], { isProjectOverlay: false })
	} else {
		if (projects_overlays.shouldOpenOverlay()) {
			// first put content inside, then do the animation. this way, the background of the grid will be shown correctly (if the user has set a background color for a grid)
			jQuery('#lay-project-overlay').html(result['markup'])
			// Insert background media outside #lay-project-overlay so it stays fixed
			// Place it before #lay-overlays if it exists, otherwise before #lay-project-overlay in DOM so it appears behind
			if (result['project_overlay_background_media']) {
				var $bgMediaContainer = jQuery('#lay-project-overlay-background-media')
				if ($bgMediaContainer.length === 0) {
					// Create container before #lay-overlays if it exists, otherwise before #lay-project-overlay
					var $target = jQuery('#lay-overlays')
					if ($target.length === 0) {
						$target = jQuery('#lay-project-overlay')
					}
					$target.before('<div id="lay-project-overlay-background-media"></div>')
					$bgMediaContainer = jQuery('#lay-project-overlay-background-media')
				}
				$bgMediaContainer.html(result['project_overlay_background_media'])
				// Set initial hiding state based on animation type (same as overlay)
				var animation = layData.po_animation || 'slideup'
				if (animation !== 'none') {
					var hidingStyle = ''
					switch (animation) {
						case 'slideup':
							hidingStyle = 'transform: translateY(100%);'
							break
						case 'slidedown':
							hidingStyle = 'transform: translateY(-100%);'
							break
						case 'fadein':
							hidingStyle = 'opacity: 0;'
							break
					}
					if (hidingStyle) {
						$bgMediaContainer.attr('style', hidingStyle)
					}
				}
			} else {
				// Remove background media container if no background media
				jQuery('#lay-project-overlay-background-media').remove()
			}
			projects_overlays.removeLoadingIndicator()

			setTimeout(function () {
				// Emit event before animation (content is already inserted)
				window.laytheme.emit('project_overlay_before_animate_in')
				window.laytheme.emit('project_overlay_open_start', jQuery('#lay-project-overlay'), result['obj'])

				if (layData.po_opening_behaviour == 'loaded') {
					projects_overlays.animateIn(function () {
						projects_overlays.insertCloseIcon()
						// set body attributes, need to do this before triggering newpageshown to make sure the correct catids are set so prevnext controller works

						utility_controller.setBodyClasses(result['obj'])
						window.laytheme.emit('project_overlay_open_end', jQuery('#lay-project-overlay'), result['obj'])
						globalevents_controller.triggerNewPageShown({}, result['type'], result['obj'], { isProjectOverlay: true })
						setTimeout(function () {
							window.laytheme.emit('transition_in', 'project_overlay')
						}, 0)
					})
				} else {
					// immediate
					// ⚠️ Note: hasAnimatedIn() has a bug where only one caller gets notified (see projects_overlays.js)
					// This is okay here since this path and the one below are mutually exclusive
					projects_overlays.hasAnimatedIn().then(function () {
						projects_overlays.insertCloseIcon()
						// set body attributes, need to do this before triggering newpageshown to make sure the correct catids are set so prevnext controller works

						utility_controller.setBodyClasses(result['obj'])
						window.laytheme.emit('project_overlay_open_end', jQuery('#lay-project-overlay'), result['obj'])
						globalevents_controller.triggerNewPageShown({}, result['type'], result['obj'], { isProjectOverlay: true })
						setTimeout(function () {
							window.laytheme.emit('transition_in', 'project_overlay')
						}, 0)
					})
				}
			}, 0)
		} else if (!projects_overlays.shouldCloseOverlay() && projects_overlays.isOverlayDisplayBlock()) {
			// navigate from project to another project. here i leave the project overlay open and just replace the content:
			// ⚠️ Note: hasAnimatedIn() has a bug where only one caller gets notified (see projects_overlays.js)
			// This is okay here since this path and the one above are mutually exclusive
			projects_overlays.hasAnimatedIn().then(function () {
				jQuery('#lay-project-overlay').html(result['markup'])
				// Insert background media outside #lay-project-overlay so it stays fixed
				// Place it before #lay-overlays if it exists, otherwise before #lay-project-overlay in DOM so it appears behind
				if (result['project_overlay_background_media']) {
					var $bgMediaContainer = jQuery('#lay-project-overlay-background-media')
					if ($bgMediaContainer.length === 0) {
						// Create container before #lay-overlays if it exists, otherwise before #lay-project-overlay
						var $target = jQuery('#lay-overlays')
						if ($target.length === 0) {
							$target = jQuery('#lay-project-overlay')
						}
						$target.before('<div id="lay-project-overlay-background-media"></div>')
						$bgMediaContainer = jQuery('#lay-project-overlay-background-media')
					}
					$bgMediaContainer.html(result['project_overlay_background_media'])
					// Set initial hiding state based on animation type (same as overlay)
					var animation = layData.po_animation || 'slideup'
					if (animation !== 'none') {
						var hidingStyle = ''
						switch (animation) {
							case 'slideup':
								hidingStyle = 'transform: translateY(100%);'
								break
							case 'slidedown':
								hidingStyle = 'transform: translateY(-100%);'
								break
							case 'fadein':
								hidingStyle = 'opacity: 0;'
								break
						}
						if (hidingStyle) {
							$bgMediaContainer.attr('style', hidingStyle)
						}
					}
				} else {
					// Remove background media container if no background media
					jQuery('#lay-project-overlay-background-media').remove()
				}
				projects_overlays.insertCloseIcon()

				// Emit event for project-to-project navigation (no animation, just content replacement)
				window.laytheme.emit('project_overlay_before_animate_in')
				window.laytheme.emit('project_overlay_open_start', jQuery('#lay-project-overlay'), result['obj'])

				// set body attributes, need to do this before triggering newpageshown to make sure the correct catids are set so prevnext controller works

				utility_controller.setBodyClasses(result['obj'])

				window.laytheme.emit('project_overlay_open_end', jQuery('#lay-project-overlay'), result['obj'])
				globalevents_controller.triggerNewPageShown({}, result['type'], result['obj'], { isProjectOverlay: true })
			})
		} else {
			// When closing back to the overview we originally opened the project
			// overlay from, that overview is still present underneath the overlay.
			// Keep that exact DOM instead of rebuilding and animating an identical
			// page again. Besides being unnecessary, replacing it briefly resets
			// layout-dependent controllers such as horizontal scroll.
			var returningToExistingUnderlay = projects_overlays.shouldCloseOverlay() && projects_overlays.isSameStateOfLastOverview(window.history.state)

			// insert hide css for animation transition:
			if (!returningToExistingUnderlay) {
				window.laytheme.emit('before_content_replacement')
			}

			// close overlay once the new page was loaded behind the project overlay
			if (projects_overlays.shouldCloseOverlay()) {
				projects_overlays.removeCloseIcon()
				projects_overlays.animateOut(function () {
					projects_overlays.destroyOverlay()
				})
			}

			if (!returningToExistingUnderlay) {
				jQuery('body>.lay-content').replaceWith(result['markup'])
			}
			// i wont pass result['layoutObj'] anymore to newpageshown. the reason is:
			// when the website initializes I do not pass a layoutObj to the newpage event, not sure if I even could
			// and also I think nobody really uses that object anyways

			// set body attributes, need to do this before triggering newpageshown to make sure the correct catids are set so prevnext controller works
			utility_controller.setBodyClasses(result['obj'])

			globalevents_controller.triggerNewPageShown({}, result['type'], result['obj'], { isProjectOverlay: false })
		}
	}

	// if i dont do a timeout, the animation will be abrupt, causing a background color for example to just appear instead of fading in properly
	// seems that 0 is not enough of a timeout here, so i use 50
	// i guess it is because .replaceWith(result['markup']); might be called at the same time or after hide-content was removed
	// i totally need at least a settimeout 0, to make sure the new dom elements exist

	// The existing underlay never left, so it needs neither a reveal nor a
	// navigation lifecycle. Only the overlay itself animates out.
	if (!projects_overlays.shouldOpenOverlay() && !returningToExistingUnderlay) {
		setTimeout(function () {
			var transitionInType = !projects_overlays.shouldCloseOverlay() && projects_overlays.isOverlayDisplayBlock() ? 'project_overlay' : undefined
			window.laytheme.emit('transition_in', transitionInType)
		}, 0)
	}

	// Apply document title from server (Yoast SEO etc.) so <title> matches full page load
	if (result.document_title) {
		history_controller.updateCurrentStateTitle(result.document_title)
	}

	// Apply page settings CSS (menu colors, overlay burger, etc.) for this page so AJAX navigation shows correct styles.
	page_settings_styles_restore.applyStyles(result.page_settings_styles)
}

var hideRegions = function () {
	window.laytheme.emit('transition_out')
	// not doing this here anymore cause i do it in animations_controller.js
	// jQuery('body').addClass('hide-content');
}

var loadMasterCache = function () {
	// Only load master cache if the cache feature is enabled
	if (layData.activate_lay_cache !== '1') {
		stateMap.masterCache = {}
		return
	}

	jQuery.ajax({
		url: layData.ajax_url,
		data: {
			action: 'get_laytheme_master_cache',
		},
		type: 'post',
		success: function (response) {
			try {
				stateMap.masterCache = JSON.parse(response)
			} catch (e) {
				stateMap.masterCache = {}
			}
		},
		error: function () {
			stateMap.masterCache = {}
		},
	})
}

var i = function () {
	setjqueryMap()

	window.laytheme.once('newpageshown', function (markup, type, obj) {
		lastFooterId = obj['footerid']
	})

	page_settings_styles_restore.i()

	// Bind hover events for preloading anchors with data-id and data-type
	preload_controller.bindPreloadHoverEvents()
}

export default layout_controller
